// extracted by mini-css-extract-plugin
export default {"back-button":"_1QFaXXehc9YBGoI_a9YS4x"};